export default "__VITE_ASSET__BDP1rCQV__"